jQuery(document).ready(function( $ ){
	// START JQUERY

	logit = (typeof logit !== 'undefined')? logit : false;

	masonry_enable = (typeof masonry_enable !== 'undefined')? masonry_enable : false;
	masonry_refresh = (typeof masonry_refresh !== 'undefined')? masonry_refresh : true;
	masonry_grid = (typeof masonry_grid !== 'undefined')? masonry_grid : '.masonry';
	masonry_item = (typeof masonry_item !== 'undefined')? masonry_item : '.masonry-item';


	if(masonry_enable) {
		if(logit) console.log('[MASONRY] Enabled');
		if(logit == 2) console.log('[MASONRY] Grid:' + masonry_grid + ' Item: ' + masonry_item);

		//updated selectors

		    $(masonry_grid).masonry({
		        itemSelector: masonry_item,
		  			percentPosition: true
		    });

				$(masonry_grid).imagesLoaded().progress( function() {
				  $(masonry_grid).masonry('layout');
				}); 


	} else {
		if(logit == 2) console.log('[MASONRY] Disabled');
		if(logit == 2) console.log('[VIDEO LOOP] add javascript variable masonry_enable. Other variables: masonry_refresh, masonry_grid, masonry_item');
	}





	// END JQUERY
});
